





import { Component, Prop, Vue } from "vue-property-decorator";

// Types
import { IClient } from "@/models/clients";
import { IAccount } from "@/models/accounts";

@Component
export default class AdminClientAccountsView extends Vue {
  // Props

  @Prop({ required: true })
  public client!: IClient;

  @Prop({ required: true })
  public accountId!: IAccount["id"];
}
